module.exports = __webpack_public_path__ + "static/media/ambassador-video-preview.mp4.07a5e65c.png";